import { POPUP_STORAGE_KEY } from './constants'
import type { PopupStorageVariant, PopupData } from './types'

export class PopupStorage {
  private readonly _blockId: string
  private readonly _storageVariant: PopupStorageVariant

  constructor(
    blockId: string,
    storageVariant: PopupStorageVariant = 'localStorage',
  ) {
    this._blockId = blockId
    this._storageVariant = storageVariant
  }

  private parseData(data: string | null): PopupData | null {
    if (!data) {
      return null
    }

    try {
      const obj = JSON.parse(data ?? '{}')
      return obj
    } catch (error) {
      return null
    }
  }

  public saveData(data: PopupData): void {
    try {
      this.storageType.setItem(
        `${POPUP_STORAGE_KEY}-${this._blockId}`,
        JSON.stringify(data),
      )
    } catch (e) {}
  }

  public loadData(): PopupData | null {
    try {
      return this.parseData(
        this.storageType.getItem(`${POPUP_STORAGE_KEY}-${this._blockId}`),
      )
    } catch (e) {
      return null
    }
  }

  get storageType() {
    return this._storageVariant === 'sessionStorage'
      ? sessionStorage
      : localStorage
  }
}
